import { createRouter, createWebHistory } from "@ionic/vue-router";
import BottomMenu from "../views/layout/BottomMenu.vue";

const routes = [
    {
        path: "/",
        redirect: "/root/inspections",
    },
    {
        name: "inspection-show",
        path: "/inspections/:id",
        component: () => import("@/views/inspections/Edit.vue"),
        middleware: true,
    },
    // inspection-information
    {
        name: "inspection-information",
        path: "/inspection-information/:id",
        component: () => import("@/views/inspections/Information.vue"),
        middleware: true,
    },
    // list all findings
    {
        name: "findings-list",
        path: "/findings",
        component: () => import("@/views/Findings.vue"),
        middleware: true,
    },
    {
        path: "/root",
        component: BottomMenu,
        meta: {
            middleware: true,
        },
        children: [
            {
                path: "/root",
                redirect: "/root/inspections",
            },
            {
                path: "/root/dashboard",
                redirect: "/root/inspections",
            },
            {
                name: "inspections",
                path: "/inspections",
                redirect: "/root/inspections",
            },
            // Inspections
            {
                name: "inspections-list",
                path: "/root/inspections",
                component: () => import("@/views/inspections/Index.vue"),
                middleware: true,
            },

            // Actions
            {
                name: "actions-list",
                path: "actions",
                component: () => import("@/views/actions/Index.vue"),
                middleware: true,
            },

            // Profile
            {
                name: "account",
                path: "account",
                component: () => import("@/views/Account.vue"),
                middleware: true,
            },
        ],
    },
    // Support form
    {
        name: "support-form",
        path: "/support-form",
        component: () => import("@/views/SupportForm.vue"),
        middleware: true,
    },
    // image editor
    {
        name: "image-editor",
        path: "/image-editor",
        component: () => import("@/views/ImageEditorV3.vue"),
        middleware: true,
    },
    // camera
    // {
    //     name: "camera",
    //     path: "/camera",
    //     component: () => import("@/views/Camera.vue"),
    //     middleware: true,
    // },
    // action create
    {
        name: "action-create",
        path: "/action-create",
        component: () => import("@/views/actions/Create.vue"),
        middleware: true,
    },

    // action edit
    {
        name: "action-edit",
        path: "/action-edit",
        component: () => import("@/views/actions/Edit.vue"),
        middleware: true,
    },
    // Addresses
    {
        name: "addresses",
        path: "/addresses",
        component: () => import("@/views/Addresses.vue"),
        middleware: true,
    },
    // Location items
    {
        name: "location-item-edit",
        path: "/location-item-edit",
        component: () => import("@/views/location_items/Edit.vue"),
        middleware: true,
    },
    // location item create
    {
        name: "location-item-create",
        path: "/location-item-create",
        component: () => import("@/views/location_items/Create.vue"),
        middleware: true,
    },
    // Location item components
    {
        name: "location-item-component-edit",
        path: "/location-item-component-edit",
        component: () => import("@/views/location_item_components/Edit.vue"),
        middleware: true,
    },

    // Sub location item component
    {
        name: "sub-location-item-component-edit",
        path: "/sub-location-item-component-edit",
        component: () => import("@/views/location_item_components/Edit.vue"),
        middleware: true,
    },

    // observations
    {
        name: "observation-create",
        path: "/observation-create",
        component: () => import("@/views/observations/Create.vue"),
        middleware: true,
    },
    {
        name: "observation-show",
        path: "/observation-show",
        component: () => import("@/views/observations/Show.vue"),
        middleware: true,
    },
    {
        name: "observation-edit",
        path: "/observation-edit",
        component: () => import("@/views/observations/Edit.vue"),
        middleware: true,
    },

    //measurements
    {
        name: "measurement-create",
        path: "/measurement-create",
        component: () => import("@/views/measurements/Create.vue"),
        middleware: true,
    },
    {
        name: "measurement-show",
        path: "/measurement-show",
        component: () => import("@/views/measurements/Show.vue"),
        middleware: true,
    },
    {
        name: "measurement-edit",
        path: "/measurement-edit",
        component: () => import("@/views/measurements/Edit.vue"),
        middleware: true,
    },
    {
        name: "measurement-bulk",
        path: "/measurement-bulk",
        component: () => import("@/views/measurements/Bulk.vue"),
        middleware: true,
    },
    {
        path: "/login",
        name: "login",
        component: () => import("@/views/Login.vue"),
    },
    // image gallery
    {
        name: "image-gallery",
        path: "/image-gallery/:id",
        component: () => import("@/views/ImageGallery.vue"),
        middleware: true,
    },
    // location item tree
    {
        name: "location-item-tree",
        path: "/location-item-tree/:id",
        component: () => import("@/views/location_items/Index.vue"),
        middleware: true,
    },
    // forms index and edit. Gets a inspection id on index and form id on edit
    {
        name: "forms-inspection",
        path: "/forms-inspection/:id",
        component: () => import("@/views/forms/IndexFormInspections.vue"),
        middleware: true,
    },
    // IndexFormLocationItemComponents
    {
        name: "forms-location-item-component",
        path: "/forms-location-item-component/:id",
        component: () => import("@/views/forms/IndexFormLocationItemComponents.vue"),
        middleware: true,
    },
    // measurement instruments index, gets a inspection id on index and measurement id on edit
    {
        name: "measurement-instruments",
        path: "/measurement-instruments/:id",
        component: () => import("@/views/measurement_instruments/Index.vue"),
        middleware: true,
    },
    // location systems index and edit, gets a inspection id on index and location system id on edit
    {
        name: "location-systems",
        path: "/location-systems/:id",
        component: () => import("@/views/location_systems/Index.vue"),
        middleware: true,
    },

    // documents index and edit, gets a inspection id on index and document id on edit
    {
        name: "documents",
        path: "/documents/:id",
        component: () => import("@/views/documents/Index.vue"),
        middleware: true,
    },
    // checklists only index, gets a inspection id
    {
        name: "inspection-checklists",
        path: "/inspection-checklists/:id",
        component: () => import("@/views/checklists/InspectionChecklists.vue"),
        middleware: true,
    },
    // checklists for location_item_components, gets a location_item_component_uuid
    {
        name: "location-item-component-checklists",
        path: "/location-item-component-checklists/:id",
        component: () => import("@/views/checklists/LocationItemComponentChecklists.vue"),
        middleware: true,
    },
    {
        name: "regulations",
        path: "/regulations/:id",
        component: () => import("@/views/regulations/Index.vue"),
        middleware: true,
    },
    // inspewction-interval
    {
        name: "inspection-interval",
        path: "/inspection-interval/:id",
        component: () => import("@/views/inspection_interval/Index.vue"),
        middleware: true,
    },
    // observations index and edit, gets a location_item_component_uuid on index and location_item_component_uuid on edit
    {
        name: "observations",
        path: "/observations/:id",
        component: () => import("@/views/observations/Index.vue"),
        middleware: true,
    },
    // measurements index and edit, gets a location_item_component_uuid on index and location_item_component_uuid on edit
    {
        name: "measurements",
        path: "/measurements/:id",
        component: () => import("@/views/measurements/Index.vue"),
        middleware: true,
    },
    // ComponentDetails from location item components
    {
        name: "component-details",
        path: "/component-details/:id",
        component: () => import("@/views/location_item_components/ComponentDetails.vue"),
        middleware: true,
    },
    // Samples
    {
        name: "samples",
        path: "/samples/:id",
        component: () => import("@/views/samples/Index.vue"),
        middleware: true,
    },
    // Scios codes
    {
        name: "scios-codes",
        path: "/scios-codes/:id",
        component: () => import("@/views/scios_codes/Index.vue"),
        middleware: true,
    },
    // CloseInspectionPage
    {
        name: "close-inspection",
        path: "/close-inspection/:id",
        component: () => import("@/views/inspections/CloseInspection.vue"),
        middleware: true,
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    strict: true,
});

router.beforeEach(async (to, from, next) => {
    if (to.meta.middleware) {
        if (localStorage.getItem("bearer") !== null) {
            return next(); // redirect to dashboard  if user is logged in
        } else {
            return next({ name: "login", query: { redirect: to.path } }); // redirect to login page if not logged in
        }
    } else {
        return next();
    }
});

export default router;
